import React from "react";
import DocsSidebar from "./docs-sidebar";
import DocsHeader from "./docs-header";
import PageContent from "src/components/Layout/PageContent";

interface DocsLayoutProps {
  header?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Standalone layout component for documentation pages.
 * Provides a dedicated docs sidebar with toggle functionality, similar to NavigationMenu.
 * Reuses PageContent for consistent styling with the rest of the site.
 */
function DocsLayout({ header, children }: DocsLayoutProps) {
  return (
    <div className="flex flex-row min-h-screen">
      {/* Docs Sidebar */}
      <DocsSidebar />

      {/* Main Content Area */}
      <PageContent>
        <DocsHeader id="docs-header" />
        {header}
        {children}
      </PageContent>
    </div>
  );
}

export default React.memo(DocsLayout);
